<template>
  <div class="text-center">
    <v-dialog
      v-model="modalPdfStatus"
      max-width="1000px"
			persistent
      scrollable
    >
      <v-card min-height="90vh">
        <v-card-title class="pa-0">
            <div class="d-flex flex-row flex-grow-1 align-center justify-space-between py-2 px-8">
							<div class="d-flex flex-row align-center justify-start">
								<v-icon color="#959595" class="mr-2">mdi-file-pdf-box</v-icon>
								<p class="mb-0 font-weight-bold text-primary body-1">{{contractType}}</p>
							</div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										small
										color="#959595"
										@click="$store.commit('contracts/setContractPdfModal', null)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark>mdi-close</v-icon>
									</v-btn>
								</template>
								<span>Cerrar</span>
							</v-tooltip>
						</div>
				</v-card-title>
				<v-card-text class="pa-0">
					<iframe :src="contractPdf" width="100%" class="fill-height d-flex flex-grow-1"></iframe>
        </v-card-text>
        <v-card-actions class="pa-0" v-if="canShowActions">
					<div class="d-flex flex-grow-1 justify-end py-2 px-8">
						<v-tooltip bottom v-if="costTableHealthy">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									color="green"
									class="mb-0"
									small
									v-bind="attrs"
									v-on="on"
									dark
									v-if="canSendEmail"
									@click="sendEmail"
								>
									<v-icon small>mdi-email-outline</v-icon>
									<p class="mb-0 ml-2 caption">Enviar por Email a {{partContractType}}</p>
								</v-btn>
							</template>
							<span>Se enviará correo al usuario con una copia del contrato</span>
						</v-tooltip>
						<div v-else>
							<v-chip
								class="ma-2"
								color="orange"
								label
								small
								outlined>
								<v-icon left>
									mdi-alert-outline
								</v-icon>
								La tabla de costos asociada al contrato debe incluir Etapas de Pago y un monto total superior a cero.
							</v-chip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										dark
										small
										color="success"
										@click="goToCostTable"
										v-bind="attrs"
										v-on="on"
									>
										<p class="mb-0 ml-2 caption">Ir a Tabla de Costo</p>
									</v-btn>
								</template>
								<span>Ir a la tabla de costos y asignar programación</span>
							</v-tooltip>
						</div>
					</div>
				</v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { sendContractPdfEmail } from '@/helpers/api/contracts'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import { getCostTableTotal } from '@/helpers/tablecostHelpers.js'
import contractStatuses from '@/components/Helpers/Constants/contract.js'

export default {
  name: 'ContractPdfModal',
  data: () => ({
		indexModal: + new Date(),
		costTableTotal: 0
  }),
  computed: {
		canShowActions(){
			const modal = this.$store.state.contracts?.contractPdfModal
			return !(modal && modal.viewer_only)
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		modalPdfStatus(){
			return !!this.$store.state.contracts.contractPdfModal
		},
		contractPdf(){
			if(this.$store.state.contracts.contractPdfModal?.forced_pdf){
				return this.$store.state.contracts.contractPdfModal?.forced_pdf.file.file_link
			}
			return this.$store.state.contracts.contractPdfModal.pdf.file.file_link
		},
		canSendEmail(){
			return this.$store.state.contracts.contractPdfModal?.last_status?.status <= contractStatuses.OBSERVADO_CONTRAPARTE ||  this.$store.state.contracts.contractPdfModal?.last_status?.status <= contractStatuses.RECHAZADO   
		},
		contract(){
			return this.$store.state.contracts.contractPdfModal
		},
		contractType(){
			let contractType = 'Contrato'
			if(this.contract.addendum_to_contract_id){
				contractType = 'Anexo de Contrato'
			}
			else if(this.contract.subcontract_to_contract_id){
				contractType = 'Subcontrato'
			}
			return contractType
		},
		partContractType(){
			return this.contract.subcontract_to_contract_id ? 'Subcontratista' : 'Cliente'
		},
		costTable(){
			return this.contract?.cost_table || {}
		},
		costTablePayments(){
			return this.contract?.cost_table?.payments || []
		},
		costTableHealthy(){
			// const totals = this.costTableTotal.total_cost_uf || this.costTableTotal.total_cost_clp
			// return this.costTablePayments.length > 0 && totals > 0
			return this.costTablePayments.length
		}
	},
	watch: {
		costTable: {
			handler(newVal){
				this.costTableTotal = getCostTableTotal(newVal)
			},
			immediate: true
		}
	},
  mounted(){
  },
  methods: {
		goToCostTable(){
			this.$router.push({ name: 'ProjectCostBreakdown', params: { id: this.contract.morphable_id }, hash: '#summary' })
			this.$store.commit('contracts/setContractPdfModal', null)
		},
		async sendEmail(){
			if(this.contract.pdf){
				try {
					await sendContractPdfEmail({contract_id: this.contract.id})
					const data = {contract_id: this.contract.id}
					eventBus.$emit('reloadInformation', data)
					const messageData = {
						message: 'Se ha enviado correctamente el correo al cliente',
						title: 'Correo enviado',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.$store.dispatch('general/addMessage', messageData)
					this.$store.commit('contracts/setContractPdfModal', null)
				} catch (error) {
					const messageData = {
						message: 'Hubo un error en la operación, por favor intenta nuevamente',
						title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
					}
					this.$store.dispatch('general/addMessage', messageData)
				}
			}
		}
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>